import { AmplitudeProvider } from './AmplitudeProvider';
import { BrazeProvider } from './BrazeProvider';

export const AMPLITUDE_PROVIDER = Object.freeze(new AmplitudeProvider());
export const BRAZE_PROVIDER = Object.freeze(new BrazeProvider());
